import React from 'react';
import PropTypes from 'prop-types';
import {Form, TextArea} from 'semantic-ui-react';

const BasicTextArea = (props) => (
    <Form.Field>
        {props.label}
        <TextArea type="textarea"
               value={props.value}
               onChange={(event, data) => props.onValueChanged(data.value)}/>
    </Form.Field>
);

BasicTextArea.propTypes = {
    label: PropTypes.string,
    value: PropTypes.any.isRequired,
    onValueChanged: PropTypes.func.isRequired
};

export default BasicTextArea;


// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/TextArea.jsx